<template>
    <footer
        :class="{
            'footer-locked': footerLocked
        }"
    >
        <LayoutFooterNewsletter />
        <div class="bg-base-200 border-t-2 border-primary">
            <section class="flex justify-between items-center px-6 max-w-screen-3xl m-auto h-20">
                <LayoutLogo size="sm" class="h-10" />

                <LayoutSocialMedia :data="data" />
            </section>
        </div>

        <div class="bg-base-100 sm:bg-base-200 border-t border-secondary">
            <section class="flex flex-col sm:flex-row sm:gap-6 max-w-screen-3xl m-auto sm:px-6 sm:py-10">
                <LayoutFooterNavigation :data="data" />
            </section>
        </div>

        <div class="bg-primary text-primary-content border-t border-secondary">
            <section class="flex flex-col px-4 max-w-screen-3xl m-auto pb-4 sm:px-6">
                <div class="flex flex-wrap justify-start py-6 lg:p-0 lg:gap-4">
                    <LayoutServiceNavigation v-if="serviceNavigation" :navigation="serviceNavigation" link-style="text-xs py-3.5 underline hover:no-underline mr-4 lg:m-0" />
                </div>

                <div class="text-left">
                    <p class="text-xs">
                        <i18n-t
                            keypath="layout.footer.term"
                            tag="label"
                            for="layout.footer.tos"
                            scope="global"
                        >
                            <a
                                href="https://policies.google.com/terms?hl=en"
                                target="_blank"
                                rel="noopener"
                                class="font-semibold underline hover:no-underline"
                            >
                                {{ $t('layout.footer.tos') }}
                            </a>
                            <a
                                href="https://policies.google.com/privacy?hl=en"
                                target="_blank"
                                rel="noopener"
                                class="font-semibold underline hover:no-underline"
                            >
                                {{ $t('layout.footer.dataprotection') }}
                            </a>
                        </i18n-t>
                    </p>
                    <p class="text-xs">
                        {{ $t('layout.footerLight.copyright', { 'year': new Date().getFullYear() }) }}
                    </p>
                </div>
            </section>
        </div>
    </footer>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    data: Schemas['CmsElementA4gFooter']['config']
}>()

const serviceNavigation = computed(() => {
    return props.data?.bottomNavigation?.value
})

// Footer lock functionality
const { footerLocked } = useFooterLock()
</script>
